module.exports = __webpack_public_path__ + "img/yy1.b965981d.png";